import React, { Component } from "react"
import Select from "../../../components/Select"

class ClassB extends Component {

    handleChange = (field, value) => {
        const detalhes = Object.assign({}, this.props.detalhes)
        const errors = Object.assign({}, this.props.errors)

        detalhes[field] = value
    
        if(field === "supports_class_b") {
            const notChecked = value === false
            
            if(notChecked) {
                for(let fieldDetalhes in detalhes) {
                    if(fieldDetalhes !== "supports_class_b") {
                        if(fieldDetalhes in errors) {
                            delete errors[fieldDetalhes]
                            this.props.setErrors(errors) 
                        }
                    }
                }
            }
        }

        if(field in errors) {
            delete errors[field]
            this.props.setErrors(errors)
        }
        
        this.props.setDetalhes(detalhes)
    }
    

    render() {
        const { detalhes, optionsSelect, errors, isTemplate } = this.props

        return(
            <div className="hdv-form-default">
                
                <div className="row">
                    <div className="col-md-12">
                        <label className="required" htmlFor="supports_class_b" title="O dispositivo suporta Classe B">O dispositivo suporta Classe B</label>
                        <input
                            type='checkbox'
                            checked={detalhes.supports_class_b}
                            id="supports_class_b"
                            onChange={(e) => this.handleChange("supports_class_b", e.target.checked)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-supports_class_b'>{ errors["supports_class_b"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required" htmlFor="class_b_timeout" title="Tempo limite de downlink confirmado de Classe B (segundos)">Tempo limite de downlink confirmado de Classe B (segundos)</label>
                        <input
                            type='text'
                            value={detalhes.class_b_timeout ?? ""}
                            id="class_b_timeout"
                            disabled={!detalhes.supports_class_b || isTemplate}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("class_b_timeout", value)
                            }}
                        />
                        <span id='validacao-class_b_timeout'>{ errors["class_b_timeout"] ?? ""  }</span>
                    </div>
                    <div className="col-md-6">
                        <label className="required" title="Periodicidade do slot de ping de classe B">Periodicidade do slot de ping de classe B</label>
                        <Select
                            options={optionsSelect.class_b_ping_slot_nb_k }
                            value={detalhes.class_b_ping_slot_nb_k}
                            onChange={(e) => this.handleChange("class_b_ping_slot_nb_k", e)}
                            disabled={!detalhes.supports_class_b || isTemplate}
                        />
                        <span id='validacao-class_b_ping_slot_nb_k'>{ errors["class_b_ping_slot_nb_k"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required" htmlFor="class_b_ping_slot_dr" title="Taxa de dados do slot de ping de classe B">Taxa de dados do slot de ping de classe B</label>
                        <input
                            type='text'
                            value={detalhes.class_b_ping_slot_dr ?? ""}
                            id="class_b_ping_slot_dr"
                            disabled={!detalhes.supports_class_b || isTemplate}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("class_b_ping_slot_dr", value)
                            }}
                        />
                        <span id='validacao-class_b_ping_slot_dr'>{ errors["class_b_ping_slot_dr"] ?? ""  }</span>
                    </div>
                    <div className="col-md-6">
                        <label className="required" htmlFor="class_b_ping_slot_freq" title="Frequência do slot de ping de classe B (Hz)">Frequência do slot de ping de classe B (Hz)</label>
                        <input
                            type='text'
                            value={detalhes.class_b_ping_slot_freq ?? ""}
                            id="class_b_ping_slot_freq"
                            disabled={!detalhes.supports_class_b || isTemplate}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("class_b_ping_slot_freq", value)
                            }}
                        />
                        <span id='validacao-class_b_ping_slot_freq'>{ errors["class_b_ping_slot_freq"] ?? ""  }</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default ClassB